module.exports = __webpack_public_path__ + "img/banner1.051a05b2.png";